export default "__VITE_ASSET__CTBkSFVF__"